import { render, staticRenderFns } from "./PublicTransferPage.vue?vue&type=template&id=c9e90344&scoped=true"
import script from "./PublicTransferPage.vue?vue&type=script&lang=js"
export * from "./PublicTransferPage.vue?vue&type=script&lang=js"
import style0 from "./PublicTransferPage.vue?vue&type=style&index=0&id=c9e90344&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9e90344",
  null
  
)

export default component.exports